import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Spinner } from "reactstrap";
import { useEvaluationSystem } from "./hooks/useEvaluationSystem";
import EvaluationActivityCard from "./components/EvaluationActivityCard";
import new1Bg from "../../assets/images/new1Bg.png";
import neoLogo from "../../assets/images/Neo_Logo_A.svg";

const EvaluationSystem = () => {
    document.title = "Matriz de Habilidades | NeoApp";
    const navigate = useNavigate();

    // Preload da imagem de fundo para evitar fundo escuro antes de renderizar
    const [bgLoaded, setBgLoaded] = useState(false);
    useEffect(() => {
        const img = new Image();
        img.src = new1Bg;
        img.onload = () => setBgLoaded(true);
        img.onerror = () => setBgLoaded(true);
    }, []);

    const {
        activities,
        loading,
        openActivityId,
        actions: { toggleAccordion }
    } = useEvaluationSystem();

    // Modelo de fundo claro e clean global para quando não estiver pronto
    if (loading || !bgLoaded) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh", backgroundColor: "#f8f8fb" }}>
                <div className="text-center">
                    <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
                    <p className="text-muted mt-3 fw-medium font-size-16">Carregando avaliações...</p>
                </div>
            </div>
        );
    }

    return (
        <div style={{
            minHeight: "100vh",
            position: "relative",
            backgroundColor: "#001D3D", // Fallback color to avoid white flash
            backgroundImage: `url(${new1Bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed'
        }}>

            {/* Overlay claro e desfocado */}
            <div style={{
                position: "fixed",
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                backdropFilter: "blur(12px)",
                WebkitBackdropFilter: "blur(12px)",
                zIndex: 0
            }} />

            <div style={{ zIndex: 1, position: "relative" }}>

                {/* Header Premium - Compact */}
                <div className="px-3 py-3 d-flex align-items-center position-sticky top-0 w-100" style={{ zIndex: 50, boxShadow: "0 2px 10px rgba(0,0,0,0.03)", backgroundColor: "rgba(255, 255, 255, 0.65)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)" }}>
                    <div className="flex-grow-1 text-center">
                        <h3 className="mb-0 fw-bold text-dark" style={{ letterSpacing: "-0.5px" }}>Sistema de Avaliação</h3>
                        <p className="mb-0 text-muted" style={{ fontSize: "16px" }}>Acompanhe a evolução de perto</p>
                    </div>
                </div>

                <Container
                    className="py-2 custom-scrollbar"
                    style={{
                        width: "90vw",
                        maxWidth: "90vw",
                        height: "70vh",
                        overflowY: "auto",
                        margin: "0 auto",
                        marginTop: "2rem",
                        borderRadius: "16px"
                    }}
                >
                    {loading ? (
                        <div className="d-flex flex-column align-items-center justify-content-center mt-5 pt-5">
                            <Spinner color="primary" style={{ width: "3.5rem", height: "3.5rem" }} />
                            <span className="mt-4 text-muted fw-medium font-size-18">Carregando os níveis...</span>
                        </div>
                    ) : activities.length === 0 ? (
                        <div className="text-center text-muted mt-5 pt-5">
                            <i className="mdi mdi-information-outline display-3 text-secondary mb-3"></i>
                            <h4 className="fw-bold text-dark">Sem Avaliações</h4>
                            <p className="text-dark opacity-75">Nenhuma atividade foi configurada para o sistema de avaliação.</p>
                        </div>
                    ) : (
                        <div className="d-flex flex-column gap-4 pb-3 mt-4">
                            {activities.map((activity, index) => (
                                <EvaluationActivityCard
                                    key={activity.id}
                                    activity={activity}
                                    index={index}
                                    isOpen={openActivityId === activity.id}
                                    toggleAccordion={toggleAccordion}
                                />
                            ))}
                        </div>
                    )}
                </Container>

                {/* Botão de Voltar no Canto Inferior Esquerdo */}
                <div className="position-fixed" style={{ bottom: '24px', left: '24px', zIndex: 10 }}>
                    <button
                        onClick={() => navigate("/kiosk")}
                        className="btn btn-dark bg-opacity-75 rounded-circle d-flex align-items-center justify-content-center shadow-lg border-0"
                        style={{ width: "64px", height: "64px", backdropFilter: "blur(5px)", transition: "all 0.2s" }}
                        title="Voltar"
                    >
                        <i className="mdi mdi-arrow-left text-white" style={{ fontSize: "32px", marginLeft: "-2px" }}></i>
                    </button>
                </div>

                {/* Powered By (Canto Inferior Direito) */}
                <div className="position-fixed" style={{ bottom: '24px', right: '24px', zIndex: 10 }}>
                    <div className="d-flex align-items-center gap-2 opacity-50">
                        <span style={{ fontSize: "10px", fontWeight: "700", color: "#333", letterSpacing: "1px" }}>POWERED BY</span>
                        <img src={neoLogo} alt="NeoApp" style={{ height: "14px", filter: "grayscale(100%) brightness(0.2)" }} />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default EvaluationSystem;
